import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  bigAlert: {
    '& .MuiButton-root': {
      marginTop: '24px',
      border: "1px solid ".concat(palette.shades[300])
    }
  },
  alertWithClose: {
    '& .MuiAlert-message': {
      maxWidth: '1168px'
    }
  }
});
export default useStyles;